import { getAuthToken, notifyDemoModeRestricted } from './authSession';

const API_URL = process.env.REACT_APP_API_URL;

// Drop-in replacement for fetch(`${API_URL}${path}`, options) that attaches
// the current Firebase ID token - every API endpoint requires one.
export async function apiFetch(path, options = {}) {
  const token = await getAuthToken();

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  // SHOP-209: surface a demo_mode block (SHOP-207/208) to the rest of the
  // app. response.clone() is required - the ~15+ existing call sites all
  // still read response.ok/response.json() themselves on the object we
  // return, and a Response body can only be consumed once.
  if (response.status === 403) {
    try {
      const body = await response.clone().json();
      if (body?.detail?.error === 'demo_mode_restricted') {
        notifyDemoModeRestricted();
      }
    } catch {
      // Non-JSON 403 body - not a demo_mode response, ignore.
    }
  }

  return response;
}
